import '../core/enums/GameSpecificTypes.js';
import '../core/enums/MaxPayoutDataTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/TimeoutMaxValue.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryValues.js';
import '../core/enums/FreeBetWinningType.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FetchDefaultPaths.js';
import { BetResponseCode } from '../core/enums/ResponseCodes.js';
import '../../_tslib-7a01aab4.js';
import { $ as gameConfigStore, D as userInfoStore, N as applicationStore, y as platformMessageStore, a as plus, b as minus, d as divide, m as multiply, t as toFixed, i as iframeService } from '../../validateBalanceOnBet-af4f4a9b.js';
import '../core/store/chatStore.js';
import '../core/store/wageringStore.js';
import '../core/store/roundInfoStore.js';
import '../core/store/userCountStore.js';
import '../core/store/gameResultStore.js';
import '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import { notificationStore } from '../core/store/notificationStore.js';
import '../core/store/selectedResultInfoStore.js';
import '../core/store/forCrashGame/inputValidationStore.js';
import '../core/store/forCrashGame/totalBetStore.js';
import '../core/store/forCrashGame/resultReportStore.js';
import '../core/store/forCrashGame/gameStore.js';
import '../core/services/liveConnection/types.js';
import 'axios';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/ApiServices.js';
import '../../momentFormat-e9197995.js';
import '../core/polyfill.js';
import { AdditionalInputValueChangingButtons, InputTypesForChanging } from '../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/enums/BogLineGameConfig.js';
import '../core/helpers/parseQuery.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/api/BaseApiService.js';
import '../core/helpers/deepCopy.js';
import '../../table-line/t_types/enums/BetResponseCode.js';
import '../../table-line/t_types/enums/BetErrorMessages.js';
import '../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../table-line/t_types/enums/FreeChipTypes.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/formatDate.js';
import '../core/helpers/isMobile.js';
import '../core/enums/bogGameNames.js';
import '../core/helpers/updateHalfBets.js';
import 'howler';
import '../../_commonjsHelpers-17aad09c.js';

var getValidationParams = function (_a) {
    var inputType = _a.inputType, minBet = _a.minBet, maxBet = _a.maxBet, minOddStep = _a.minOddStep, minOdd = _a.minOdd, step = _a.step, responseCodeForMin = _a.responseCodeForMin, responseCodeForMax = _a.responseCodeForMax, minValue = _a.minValue, maxValue = _a.maxValue;
    var BetInput = InputTypesForChanging.BetInput, AutoCashOutInput = InputTypesForChanging.AutoCashOutInput, Other = InputTypesForChanging.Other;
    var InValidAutoCashOutOdd = BetResponseCode.InValidAutoCashOutOdd, InValidMaxAutoCashOutOdd = BetResponseCode.InValidMaxAutoCashOutOdd, InValidMaxBet = BetResponseCode.InValidMaxBet, InValidMinBet = BetResponseCode.InValidMinBet;
    switch (inputType) {
        case BetInput:
            return {
                plusOrMinusInputValueStep: minBet,
                responseCodeForMin: InValidMinBet,
                responseCodeForMax: InValidMaxBet,
                minValue: minBet,
                maxValue: maxBet,
            };
        case AutoCashOutInput:
            return {
                plusOrMinusInputValueStep: minOddStep,
                responseCodeForMin: InValidAutoCashOutOdd,
                responseCodeForMax: InValidMaxAutoCashOutOdd,
                minValue: minOdd,
                maxValue: maxValue,
            };
        case Other:
            return { plusOrMinusInputValueStep: step, responseCodeForMin: responseCodeForMin, responseCodeForMax: responseCodeForMax, minValue: minValue, maxValue: maxValue };
        default:
            return {
                plusOrMinusInputValueStep: minBet,
                responseCodeForMin: InValidMinBet,
                responseCodeForMax: InValidMaxBet,
                minValue: minBet,
                maxValue: maxBet,
            };
    }
};
var useInputValueChangingFunctions = function (_a) {
    var _b;
    var autoCashOutData = _a.autoCashOutData, additionalInputInfo = _a.additionalInputInfo; _a.dividerOrMultiplayer; var changingValue = _a.changingValue, changingValueCallback = _a.changingValueCallback, isTableLine = _a.isTableLine;
    var _c = gameConfigStore.limits, minBet = _c.minBet, maxBet = _c.maxBet, maxWin = _c.maxWin;
    var balance = userInfoStore.balance;
    var isDemo = applicationStore.isDemo;
    var isUsedInputValidationFunctionality = platformMessageStore.isUsedInputValidationFunctionality;
    var _d = additionalInputInfo || {}, inputType = _d.inputType, maxValue = _d.maxValue, minValue = _d.minValue, responseCodeForMin = _d.responseCodeForMin, responseCodeForMax = _d.responseCodeForMax, step = _d.step;
    var InsufficientFunds = BetResponseCode.InsufficientFunds, InValidMaxBet = BetResponseCode.InValidMaxBet, InValidMinBet = BetResponseCode.InValidMinBet, InValidMinBetWithValue = BetResponseCode.InValidMinBetWithValue, InValidMaxBetWithValue = BetResponseCode.InValidMaxBetWithValue;
    var plus$1 = AdditionalInputValueChangingButtons.plus, min = AdditionalInputValueChangingButtons.min, max = AdditionalInputValueChangingButtons.max, divide$1 = AdditionalInputValueChangingButtons.divide, multiply$1 = AdditionalInputValueChangingButtons.multiply, inputBlur = AdditionalInputValueChangingButtons.inputBlur, minus$1 = AdditionalInputValueChangingButtons.minus, allIn = AdditionalInputValueChangingButtons.allIn, typing = AdditionalInputValueChangingButtons.typing;
    var _e = autoCashOutData || {}, isAutoCashOut = _e.isAutoCashOut, updateAutoCashOutValue = _e.updateAutoCashOutValue, betAmount = _e.betAmount, minOddStep = _e.minOddStep, autoCashOutOdd = _e.autoCashOutOdd, minOdd = _e.minOdd;
    var BetInput = InputTypesForChanging.BetInput;
    var _f = getValidationParams({
        inputType: inputType,
        minBet: minBet,
        maxBet: maxBet,
        minOddStep: minOddStep,
        minOdd: minOdd,
        step: step,
        maxValue: maxValue,
        minValue: minValue,
        responseCodeForMax: responseCodeForMax,
        responseCodeForMin: responseCodeForMin,
    }), plusOrMinusInputValueStep = _f.plusOrMinusInputValueStep, responseCodeForMinValue = _f.responseCodeForMin, responseCodeForMaxValue = _f.responseCodeForMax, minimumValue = _f.minValue, maximumValue = _f.maxValue;
    var checkAutoCashOutOddWithBetAmount = function (changedBetAmount, index) {
        if (autoCashOutData) {
            var currentMaxAutoCashOutOdd = divide(maxWin, changedBetAmount);
            if (isAutoCashOut && autoCashOutOdd > currentMaxAutoCashOutOdd) {
                gameConfigStore.setMaxAutoCashOutOdd(toFixed(currentMaxAutoCashOutOdd, 2));
                updateAutoCashOutValue(toFixed(currentMaxAutoCashOutOdd, 2), index);
                notificationStore.setNotificationType({
                    responseCode: BetResponseCode.InValidMaxAutoCashOutOdd,
                });
            }
        }
    };
    var mappingFunctionsForChangingInputValue = (_b = {},
        _b[plus$1] = function (dividerOrMultiplayer, index) {
            var condition = plus(changingValue, plusOrMinusInputValueStep) > maximumValue;
            if (condition) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InValidMaxBetWithValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: responseCodeForMaxValue,
                    });
                }
            }
            var changedInputValue = condition ? maximumValue : plus(changingValue, plusOrMinusInputValueStep);
            inputType === BetInput && checkAutoCashOutOddWithBetAmount(changedInputValue, index);
            return changedInputValue;
        },
        _b[typing] = function (targetValue, index) {
            if (!/^[.,]/.test(targetValue) && /^\d*[.,]?\d*$/.test(targetValue)) {
                return targetValue.replace(',', '.');
            }
        },
        _b[minus$1] = function () {
            var condition = minus(changingValue, plusOrMinusInputValueStep) < minimumValue;
            if (condition) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InValidMinBetWithValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: responseCodeForMinValue,
                    });
                }
            }
            return condition ? minimumValue : minus(changingValue, plusOrMinusInputValueStep);
        },
        _b[min] = function () {
            if (inputType === BetInput && isDemo && balance < minBet) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InsufficientFunds);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: InsufficientFunds,
                    });
                }
            }
            return minBet;
        },
        _b[max] = function (dividerOrMultiplayer, index) {
            if (inputType === BetInput && isDemo && balance < maxBet) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InsufficientFunds);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: InsufficientFunds,
                    });
                }
            }
            inputType === BetInput && checkAutoCashOutOddWithBetAmount(maxBet, index);
            return maxBet;
        },
        _b[divide$1] = function (dividerOrMultiplayer) {
            if (dividerOrMultiplayer === void 0) { dividerOrMultiplayer = 2; }
            var condition = divide(changingValue, dividerOrMultiplayer) < minimumValue;
            if (condition) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InValidMinBetWithValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: responseCodeForMinValue,
                    });
                }
            }
            return condition ? minimumValue : divide(changingValue, dividerOrMultiplayer);
        },
        _b[inputBlur] = function (dividerOrMultiplayer, index) {
            if (changingValue < minimumValue || !changingValue) {
                if (isTableLine) {
                    notificationStore.setNotificationType(responseCodeForMinValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: responseCodeForMinValue,
                    });
                }
                return minimumValue;
            }
            if (changingValue > maximumValue) {
                if (isTableLine) {
                    notificationStore.setNotificationType(responseCodeForMaxValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: responseCodeForMaxValue,
                    });
                }
                inputType === BetInput && checkAutoCashOutOddWithBetAmount(maximumValue, index);
                return maximumValue;
            }
            inputType === BetInput && checkAutoCashOutOddWithBetAmount(changingValue, index);
            return changingValue;
        },
        _b[multiply$1] = function (dividerOrMultiplayer, index) {
            if (dividerOrMultiplayer === void 0) { dividerOrMultiplayer = 2; }
            var condition = multiply(changingValue, dividerOrMultiplayer) > maximumValue;
            if (condition) {
                if (isTableLine) {
                    notificationStore.setNotificationType(InValidMaxBetWithValue);
                }
                else {
                    notificationStore.setNotificationType({
                        responseCode: InValidMaxBet,
                    });
                }
            }
            var changedInputValue = condition ? maximumValue : multiply(changingValue, dividerOrMultiplayer);
            inputType === BetInput && checkAutoCashOutOddWithBetAmount(changedInputValue, index);
            return changedInputValue;
        },
        _b[allIn] = function (dividerOrMultiplayer, index) {
            if (inputType === BetInput) {
                if (!balance) {
                    if (isTableLine) {
                        notificationStore.setNotificationType(InValidMinBetWithValue);
                    }
                    else {
                        notificationStore.setNotificationType({
                            responseCode: InValidMinBet,
                        });
                    }
                    return minBet;
                }
                if (balance > maxBet) {
                    if (isTableLine) {
                        notificationStore.setNotificationType(InValidMaxBetWithValue);
                    }
                    else {
                        notificationStore.setNotificationType({
                            responseCode: InValidMaxBet,
                        });
                    }
                    inputType === BetInput && checkAutoCashOutOddWithBetAmount(maxBet, index);
                    return maxBet;
                }
                if (balance && balance < minBet) {
                    if (isTableLine) {
                        notificationStore.setNotificationType(InValidMinBetWithValue);
                    }
                    else {
                        notificationStore.setNotificationType({
                            responseCode: InValidMinBet,
                        });
                    }
                    return minBet;
                }
                if (balance && balance < maxBet && changingValue === maxBet) {
                    return balance < maxBet && changingValue === maxBet ? toFixed(balance) : toFixed(balance);
                }
                if (changingValue !== maxBet) {
                    return balance > maxBet ? maxBet : !balance || balance < minBet ? minBet : toFixed(balance);
                }
            }
        },
        _b);
    var handleChangeInputValue = function (action, dividerOrMultiplayer, index) {
        var currentInputValue = toFixed(mappingFunctionsForChangingInputValue === null || mappingFunctionsForChangingInputValue === void 0 ? void 0 : mappingFunctionsForChangingInputValue[action](dividerOrMultiplayer, index));
        if (inputType === BetInput && isUsedInputValidationFunctionality) {
            platformMessageStore.updateGameSectionData({ amount: currentInputValue }, index);
            setTimeout(function () {
                if (currentInputValue !== betAmount) {
                    iframeService.sendStakeUpdate(Number(currentInputValue));
                }
            }, 300);
        }
        changingValueCallback(currentInputValue, index);
    };
    return {
        handleChangeInputValue: handleChangeInputValue,
    };
};

export { useInputValueChangingFunctions };
